import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { _ as _slicedToArray, a as _objectSpread2 } from './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import styled from 'styled-components';
import space from '@styled-system/space';
import color from '@styled-system/color';
import border from '@styled-system/border';
import variant from '@styled-system/variant';
import typography from '@styled-system/typography';

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!canUseDOM) {
        return null;
      }
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }
      return ReactDOM.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);

  return Portal;
}(React.Component);

Portal.propTypes = {
  children: PropTypes.node.isRequired,
  node: PropTypes.any
};

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal$1 = function (_React$Component) {
  _inherits$1(Portal, _React$Component);

  function Portal() {
    _classCallCheck$1(this, Portal);

    return _possibleConstructorReturn$1(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass$1(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderPortal();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(props) {
      this.renderPortal();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      ReactDOM.unmountComponentAtNode(this.defaultNode || this.props.node);
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
      this.portal = null;
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      var children = this.props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof this.props.children.type === 'function') {
        children = React.cloneElement(this.props.children);
      }

      this.portal = ReactDOM.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(React.Component);


Portal$1.propTypes = {
  children: PropTypes.node.isRequired,
  node: PropTypes.any
};

var Portal$2 = void 0;

if (ReactDOM.createPortal) {
  Portal$2 = Portal;
} else {
  Portal$2 = Portal$1;
}

var Portal$3 = Portal$2;

/**
 * useActivify React Hook
 * Enables/Disables elements with timeouts to allow animations to
 * take place
 * @param {bool} active whether to enable to disable the element
 * @returns {obj} {
 *    @param visible {bool}  whether the element should be showed (animated in/out)
 *    @param enabled {bool}  whether the element should render (return null if false)
 * }
 */
function useActivify(active) {
  var _useState = useState(active),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var _useState3 = useState(active),
    _useState4 = _slicedToArray(_useState3, 2),
    enabled = _useState4[0],
    setEnabled = _useState4[1];
  var _enableTimeout = useRef(null);
  var _disableTimeout = useRef(null);
  var show = function show() {
    if (_disableTimeout.current) clearTimeout(_disableTimeout.current);
    setEnabled(true);
    _enableTimeout.current = setTimeout(function () {
      setVisible(true);
    }, 50);
  };
  var hide = function hide() {
    if (_enableTimeout.current) clearTimeout(_enableTimeout.current);
    setVisible(false);
    _disableTimeout.current = setTimeout(function () {
      setEnabled(false);
    }, 400);
  };
  useEffect(function () {
    if (active) show();else hide();
  }, [active]);
  return {
    visible: visible,
    enabled: enabled
  };
}

var KEY_CODES = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ENTER: 13,
  ESC: 27,
  BACKSPACE: 8,
  TAB: 9
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var POSITIONER_CONSTANTS = {
  MAX_TOOLTIP_WIDTH: 150,
  OFFSET: {
    TOP: 10,
    RIGHT: 10,
    BOTTOM: 10,
    LEFT: 10
  },
  ARROW: {
    DEFAULT: "50%",
    FULL: "100%",
    RIGHT: -6
  }
};

function usePositioner(_ref) {
  var attachTo = _ref.attachTo,
    attachee = _ref.attachee,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? "TOP" : _ref$position,
    offset = _ref.offset;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    if (!attachTo.current || !attachee.current) return;
    var rect = attachTo.current.getBoundingClientRect();
    var tooltipRect = attachee.current.getBoundingClientRect();
    var coordinates = {};
    switch (position) {
      case "TOP":
        {
          coordinates.top = rect.top - tooltipRect.height - POSITIONER_CONSTANTS.OFFSET.TOP;
          coordinates.left = rect.left - tooltipRect.width / 2 + rect.width / 2;
          coordinates.arrowCoords = {
            left: POSITIONER_CONSTANTS.ARROW.DEFAULT
          };
          break;
        }
      case "RIGHT":
        {
          coordinates.top = rect.top - tooltipRect.height / 2 + rect.height / 2;
          coordinates.left = rect.right + POSITIONER_CONSTANTS.OFFSET.RIGHT;
          coordinates.arrowCoords = {
            left: POSITIONER_CONSTANTS.ARROW.RIGHT,
            top: tooltipRect.height / 2 + POSITIONER_CONSTANTS.ARROW.RIGHT
          };
          break;
        }
      case "BOTTOM":
        {
          coordinates.top = rect.bottom + POSITIONER_CONSTANTS.OFFSET.BOTTOM;
          coordinates.left = rect.left - tooltipRect.width / 2 + rect.width / 2;
          coordinates.arrowCoords = {
            left: POSITIONER_CONSTANTS.ARROW.DEFAULT
          };
          break;
        }
      case "LEFT":
        {
          coordinates.top = rect.top - tooltipRect.height / 2 + rect.height / 2;
          coordinates.left = rect.left - tooltipRect.width - POSITIONER_CONSTANTS.OFFSET.LEFT;
          coordinates.arrowCoords = {
            left: POSITIONER_CONSTANTS.ARROW.FULL,
            top: tooltipRect.height / 2 + POSITIONER_CONSTANTS.ARROW.RIGHT
          };
          break;
        }
      default:
        {
          coordinates.top = rect.bottom + POSITIONER_CONSTANTS.OFFSET.BOTTOM;
          coordinates.left = rect.left - tooltipRect.width / 2 + rect.width / 2;
          coordinates.arrowCoords = {
            left: POSITIONER_CONSTANTS.ARROW.DEFAULT
          };
        }
    }
    var leftDiff = rect.left + rect.width / 2 - tooltipRect.width / 2 - 8;
    var rightDiff = window.innerWidth - (rect.left + rect.width / 2 + tooltipRect.width / 2) - 24;
    if (leftDiff < 0) {
      coordinates.left -= leftDiff;
      coordinates.arrowCoords.left = rect.left;
    } else {
      leftDiff = 0;
    }
    if (rightDiff < 0) {
      coordinates.left += rightDiff;
      coordinates.arrowCoords.left = tooltipRect.width / 2 - rightDiff;
    } else {
      rightDiff = 0;
    }
    if (offset && offset.left) {
      coordinates.left += offset.left;
    }
    if (offset && offset.top) {
      coordinates.top += offset.top;
    }
    setValue(coordinates);
  }, [attachTo.current, attachee.current]);
  return value;
}

function useEscapeKey(onEscape) {
  var handleKeyUp = React.useCallback(function (e) {
    if (e.keyCode === KEY_CODES.ESC) {
      onEscape(e);
    }
  });
  React.useEffect(function () {
    document.addEventListener('keyup', handleKeyUp);
    return function () {
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);
}

var TooltipColor = variant({
  scale: "tooltipColors",
  variants: {
    primary: {},
    success: {},
    danger: {}
  }
});
var TooltipSize = variant({
  prop: "size",
  scale: "tooltipSizes",
  variants: {
    small: {},
    regular: {},
    large: {}
  }
});
var TooltipMode = variant({
  prop: "mode",
  scale: "tooltipModes",
  variants: {
    active: {},
    inactive: {}
  }
});
var ArrowColorVariant = variant({
  prop: "variant",
  scale: "tooltipArrowColors",
  variants: {
    primary: {},
    success: {},
    danger: {}
  }
});
var ArrowPositionVariant = variant({
  prop: "position",
  scale: "tooltipArrowPositions",
  variants: {
    top: {},
    right: {},
    bottom: {},
    left: {}
  }
});

// Non customizable CSS props
var wrapperStyle = {
  position: "absolute",
  pointerEvents: "auto",
  zIndex: 1099999999999,
  borderRadius: 8,
  outline: "none",
  filter: "drop-shadow(rgba(0, 0, 0, 0.2) 3px 0px 12px)",
  transition: "opacity 0.2s ease, transform 0.2s ease"
};
var contentStyle = {
  maxHeight: "inherit",
  maxWidth: 550,
  overflow: "hidden",
  overflowX: "auto",
  lineHeight: 1.4
};
var arrowStyle = {
  position: "absolute",
  marginLeft: "-5px",
  border: "6px solid"
};
var ThemedWrapper = styled("div")(wrapperStyle, space, color, border, typography, TooltipColor, TooltipSize, TooltipMode);
var ThemedContent = styled("div")(contentStyle, space, color, border, typography);
var ThemedArrow = styled("div")(arrowStyle, space, color, border, ArrowColorVariant, ArrowPositionVariant);

// Customizable CSS props
ThemedWrapper.defaultProps = {
  mode: "inactive",
  borderRadius: 8,
  variant: "primary",
  size: "regular",
  fontFamily: "\"Proxima Nova\", sans-serif"
};
ThemedContent.defaultProps = {
  padding: "zero"
};
ThemedArrow.defaultProps = {
  position: "top",
  variant: "primary.bottom"
};

var css_248z = ".Tooltip_tooltipWrapper__2LPU6 {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1099999999999; }\n\n.Tooltip_tooltipOverlay__28xTu {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n\n.Tooltip_tooltip__35nZ0 {\n  opacity: 0;\n  position: absolute;\n  pointer-events: auto;\n  z-index: 2;\n  border-radius: 8px;\n  outline: none;\n  filter: drop-shadow(rgba(0, 0, 0, 0.2) 3px 0px 12px);\n  transition: 0.1s ease-in-out;\n  transform: translate3d(0, 4px, 0); }\n  .Tooltip_tooltip__35nZ0 .Tooltip_tooltipArrow__1G_2M {\n    position: absolute;\n    left: 50%;\n    margin-left: -5px;\n    border: 6px solid;\n    margin-left: -5px; }\n    .Tooltip_tooltip__35nZ0 .Tooltip_tooltipArrow__1G_2M.Tooltip_bottom__1zjAo {\n      border-top-color: transparent !important;\n      border-right-color: transparent !important;\n      border-bottom-color: #28394b;\n      border-left-color: transparent !important;\n      margin-top: -20px;\n      top: 0; }\n    .Tooltip_tooltip__35nZ0 .Tooltip_tooltipArrow__1G_2M.Tooltip_top__mkIWq {\n      border-top-color: #28394b;\n      border-right-color: transparent !important;\n      border-bottom-color: transparent !important;\n      border-left-color: transparent !important;\n      top: 100%;\n      margin-top: 0; }\n    .Tooltip_tooltip__35nZ0 .Tooltip_tooltipArrow__1G_2M.Tooltip_arrowHidden__3Z66i {\n      display: none; }\n  .Tooltip_tooltip__35nZ0 * {\n    font-family: \"Roboto\", sans-serif; }\n  .Tooltip_tooltip__35nZ0.Tooltip_tooltipActive__qnRU3 {\n    opacity: 1 !important;\n    transform: translate3d(0, 0, 0) !important; }\n\n.Tooltip_tooltipContent__uLcBp {\n  max-height: inherit !important;\n  max-width: 550px;\n  border-radius: 8px;\n  overflow: hidden;\n  overflow-x: auto;\n  line-height: 1.4; }\n  .Tooltip_tooltipContent__uLcBp.Tooltip_bottom__1zjAo {\n    margin-top: -8px; }\n\n.Tooltip_tooltipWrapperHover__2Jj0B {\n  height: auto; }\n";
var styles = {"tooltipWrapper":"Tooltip_tooltipWrapper__2LPU6","tooltipOverlay":"Tooltip_tooltipOverlay__28xTu","tooltip":"Tooltip_tooltip__35nZ0","tooltipArrow":"Tooltip_tooltipArrow__1G_2M","bottom":"Tooltip_bottom__1zjAo","top":"Tooltip_top__mkIWq","arrowHidden":"Tooltip_arrowHidden__3Z66i","tooltipActive":"Tooltip_tooltipActive__qnRU3","tooltipContent":"Tooltip_tooltipContent__uLcBp","tooltipWrapperHover":"Tooltip_tooltipWrapperHover__2Jj0B"};
styleInject(css_248z);

var modalRoot = document.getElementById("portal-root");
if (!modalRoot) {
  modalRoot = document.createElement("div");
  modalRoot.setAttribute("id", "portal-root");
  document.body.appendChild(modalRoot);
}
function Tooltip(_ref) {
  var active = _ref.active,
    position = _ref.position,
    className = _ref.className,
    prefixClassName = _ref.prefixClassName,
    attachTo = _ref.attachTo,
    onClose = _ref.onClose,
    children = _ref.children,
    offset = _ref.offset,
    dismissable = _ref.dismissable,
    themed = _ref.themed,
    variant = _ref.variant,
    size = _ref.size,
    tooltip = _ref.tooltip,
    trigger = _ref.trigger,
    hideArrow = _ref.hideArrow;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dismissed = _React$useState2[0],
    setDismissed = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    tooltipActive = _React$useState4[0],
    setTooltipActive = _React$useState4[1];
  var tooltipRef = React.useRef();
  var DOMRef = React.useRef();
  var triggerEnabled = !attachTo;
  var handleMouseEnter = React.useCallback(function () {
    if (trigger === "hover") setTooltipActive(true);
  });
  var handleMouseLeave = React.useCallback(function () {
    if (trigger === "hover") setTooltipActive(false);
  });
  var coordinates = usePositioner({
    attachTo: triggerEnabled ? DOMRef : attachTo,
    attachee: tooltipRef,
    position: position,
    offset: offset
  });
  var tooltipActiveStatus = triggerEnabled ? tooltipActive : active;
  var _useActivify = useActivify(tooltipActiveStatus && !dismissed),
    enabled = _useActivify.enabled,
    visible = _useActivify.visible;
  var activeClassName = visible ? styles.tooltipActive : "";
  var tooltipPosition = position ? position.toLowerCase() : "bottom";
  var topPositionClassName = styles[tooltipPosition];
  var handleClose = React.useCallback(function () {
    if (dismissable) setDismissed(true);
    setTooltipActive(false);
    onClose();
  });
  useEscapeKey(handleClose);
  var handleScroll = function handleScroll() {
    setTooltipActive(false);
    onClose();
  };
  React.useEffect(function () {
    if (tooltipActive || themed && active) {
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
    } else {
      window.removeEventListener("scroll", handleScroll);
    }
  }, [tooltipActive, active]);
  if (!triggerEnabled && (!attachTo || !enabled)) return null;
  var renderTooltipContent = function renderTooltipContent() {
    if (themed) {
      var arrowPosition = position ? position.toLowerCase() : "bottom";
      var tooltipActiveMode = activeClassName && coordinates.top;
      return /*#__PURE__*/React.createElement(ThemedWrapper, {
        ref: tooltipRef,
        style: coordinates,
        mode: tooltipActiveMode ? "active" : "inactive",
        variant: variant,
        size: size
      }, /*#__PURE__*/React.createElement(ThemedContent, null, coordinates.arrowCoords && /*#__PURE__*/React.createElement(ThemedArrow, {
        variant: "".concat(variant, ".").concat([arrowPosition]),
        position: arrowPosition,
        style: coordinates.arrowCoords
      }), triggerEnabled ? tooltip : children));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles.tooltip, " ").concat(activeClassName, " ").concat(prefixClassName, "-inner"),
      ref: tooltipRef,
      style: coordinates
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles.tooltipArrow, " ").concat(topPositionClassName, " ").concat(hideArrow ? styles.arrowHidden : "", " ").concat(prefixClassName, "-caret")
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles.tooltipContent, " ").concat(topPositionClassName, " ").concat(prefixClassName, "-body")
    }, children));
  };
  var renderPortal = function renderPortal() {
    var hoverEnabledClassName = triggerEnabled && enabled && trigger === "hover" ? styles.tooltipWrapperHover : "";
    return /*#__PURE__*/React.createElement(Portal$3, {
      node: document && document.getElementById("portal-root")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles.tooltipWrapper, " ").concat(className, " ").concat(prefixClassName, " ").concat(hoverEnabledClassName)
    }, /*#__PURE__*/React.createElement("div", {
      onClick: handleClose,
      className: "".concat(styles.tooltipOverlay, " ").concat(prefixClassName, "-overlay")
    }), renderTooltipContent()));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, themed && triggerEnabled ? /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-block"
    },
    ref: DOMRef,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: function onClick() {
      if (trigger === "click" && !tooltipActive) {
        setTooltipActive(true);
      }
    }
  }, children, enabled && renderPortal()) : renderPortal());
}
Tooltip.propTypes = {
  attachTo: PropTypes.object.isRequired,
  active: PropTypes.bool,
  dismissable: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  prefixClassName: PropTypes.string,
  onClose: PropTypes.func,
  position: PropTypes.string,
  themed: PropTypes.bool,
  variant: PropTypes.string,
  size: PropTypes.string,
  offset: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  }),
  tooltip: PropTypes.string,
  trigger: PropTypes.string,
  hideArrow: PropTypes.bool
};
Tooltip.defaultProps = {
  active: false,
  dismissable: false,
  children: null,
  className: "",
  prefixClassName: "",
  position: "",
  onClose: function onClose() {},
  offset: null,
  themed: false,
  variant: "primary",
  size: "regular",
  tooltip: "",
  trigger: "hover",
  hideArrow: false
};
Tooltip.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Tooltip",
  "props": {
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "dismissable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "position": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onClose": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "offset": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "top": {
            "name": "number",
            "required": false
          },
          "left": {
            "name": "number",
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "variant": {
      "defaultValue": {
        "value": "\"primary\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "size": {
      "defaultValue": {
        "value": "\"regular\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "tooltip": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "trigger": {
      "defaultValue": {
        "value": "\"hover\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "hideArrow": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "attachTo": {
      "type": {
        "name": "object"
      },
      "required": true,
      "description": ""
    }
  }
};

var css_248z$1 = ".WithTooltip_withTooltip__3IdJV {\n  padding: 4px 8px;\n  font-size: 14px;\n  font-weight: 500;\n  -webkit-font-smoothing: antialiased;\n  min-width: 32px;\n  background-color: #28394B;\n  color: #F5F5F5;\n  text-align: left; }\n\n.WithTooltip_withTooltipTooltip__Y_dPz {\n  pointer-events: none; }\n";
var styles$1 = {"withTooltip":"WithTooltip_withTooltip__3IdJV","withTooltipTooltip":"WithTooltip_withTooltipTooltip__Y_dPz"};
styleInject(css_248z$1);

function WithTooltip(_ref) {
  var children = _ref.children,
    prefixClassName = _ref.prefixClassName,
    className = _ref.className,
    onClick = _ref.onClick,
    tooltip = _ref.tooltip,
    position = _ref.position,
    disabled = _ref.disabled;
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    tooltipActive = _React$useState2[0],
    setTooltipActive = _React$useState2[1];
  var DOMRef = React.useRef();
  var timeout = React.useRef();
  var handleMouseEnter = React.useCallback(function () {
    timeout.current = setTimeout(function () {
      setTooltipActive(true);
    }, 300);
  });
  var handleMouseLeave = React.useCallback(function () {
    if (timeout.current) clearTimeout(timeout.current);
    setTooltipActive(false);
  });
  var defaultProps = {
    tooltipArrowColor: "rgba(0,0,0,0.7)",
    tooltipArrowSmall: true,
    className: styles$1.withTooltipTooltip,
    prefixClassName: "".concat(prefixClassName, "-inner")
  };
  var tooltipProps = {
    active: tooltipActive && !disabled,
    position: position,
    attachTo: DOMRef,
    onClose: handleMouseLeave
  };
  var withTooltipProps = _objectSpread2(_objectSpread2({}, tooltipProps), defaultProps);
  var tooltipContentClassName = "".concat(styles$1.withTooltip, " ").concat(prefixClassName, "-inner-wrapper");
  return /*#__PURE__*/React.createElement("span", {
    ref: DOMRef,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: onClick,
    className: "".concat(styles$1.withTooltipWrapper, " ").concat(className, " ").concat(prefixClassName)
  }, children, tooltip && /*#__PURE__*/React.createElement(Tooltip, withTooltipProps, /*#__PURE__*/React.createElement("div", {
    className: tooltipContentClassName
  }, tooltip)));
}
WithTooltip.propTypes = {
  children: PropTypes.node,
  prefixClassName: PropTypes.string,
  className: PropTypes.string,
  tooltip: PropTypes.string,
  position: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};
WithTooltip.defaultProps = {
  children: null,
  className: "",
  tooltip: "",
  position: "TOP",
  disabled: false,
  onClick: function onClick() {}
};
WithTooltip.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WithTooltip",
  "props": {
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "tooltip": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "position": {
      "defaultValue": {
        "value": "\"TOP\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

export { KEY_CODES as K, Portal$3 as P, Tooltip as T, WithTooltip as W, useEscapeKey as a, styleInject as s, useActivify as u };
